import React from 'react'
import DefautlDashboard from '../../Dashboard/Default/index'
import LiveAnalyticsScreen from '../../../Screens/GlobalUser/LiveAnalytics/live_analytics'
import QADash from './QADash'
import { Container } from 'reactstrap'
const Index = () => {
  return (
    <>
    {/* <DefautlDashboard /> */}
    {/* <LiveAnalyticsScreen /> */}


    {/* <Container className="dashboard-first-page" fluid={true}>
     <h1>QA Dashboard</h1>
    </Container> */}
    <QADash />
    </>
  )
}

export default Index
